/**
 * Default RBAC role options and license types for staff editing.
 *
 * These mirror the backend wizard_constants.py values and are used as
 * fallbacks when wizard defaults haven't been fetched yet (e.g. in the
 * DemoConversionBanner crawl flow before the wizard context is available).
 *
 * The canonical source of truth is the backend — when wizard defaults ARE
 * available (via WizardContext), prefer those over these fallbacks.
 */
import type { RoleOption } from '../types';
import { LICENSE_TYPES } from '../../../constants/licenseTypes';

export const DEFAULT_ROLE_OPTIONS: RoleOption[] = [
  { value: 'provider', label: 'Provider (Therapist, Psychiatrist, NP, etc.)', is_clinical: true },
  { value: 'clinical_director', label: 'Clinical Director', is_clinical: true },
  { value: 'supervisor', label: 'Supervisor', is_clinical: true },
  { value: 'medical_assistant', label: 'Medical Assistant', is_clinical: true },
  { value: 'admin', label: 'Admin Staff (Receptionist, Office Manager, etc.)', is_clinical: false },
  { value: 'billing', label: 'Billing - Own Clients (add-on)', is_clinical: false },
  { value: 'billing_specialist', label: 'Billing Specialist - Practice Wide', is_clinical: false },
  { value: 'intake_coordinator', label: 'Intake Coordinator', is_clinical: false },
];

export const DEFAULT_LICENSE_TYPES: string[] = [...LICENSE_TYPES];

export const DEFAULT_DEGREE_TYPES: string[] = [
  'PhD',
  'PsyD',
  'MD',
  'DO',
  'MSW',
  'MA',
  'MS',
  'MSN',
  'MEd',
  'MBA',
  'EdD',
  'DNP',
  'Other',
];
